import { MinecraftCustomSettingsUI } from "./minecraftCustomSettingsUI";
const MINECRAFT_LEVEL_TYPE_CUSTOM = 'custom';

export class MinecraftCustomSettings {

  private levelType;

  public constructor(private ui: MinecraftCustomSettingsUI, private data, private form) {
    this.render();
    const variables = form.sections.extended.variables.reduce((sum, item) => {
      sum[item.name] = item;
      return sum;
    }, {});
    this.levelType = variables['level-type'].choices[0][0];
    if (data.server['level-type']) {
      this.levelType = data.server['level-type'];
    }
  }

  private render() {
    this.ui.render().then(() => {
      this.bindEvents();
      this.handleLevelTypeChange(this.levelType);
    });
  }

  private bindEvents() {
    const currentlySelectedLevelType = this.ui.getLevelTypeValue();
    this.handleLevelTypeChange(currentlySelectedLevelType);
    this.ui.onLevelTypeChange(this.handleLevelTypeChange.bind(this));
  }

  private handleLevelTypeChange(value: string) {
    value === MINECRAFT_LEVEL_TYPE_CUSTOM ? this.ui.showCustomLevelType() : this.ui.hideCustomLevelType();
    this.levelType = value;
  }
}
